import { render } from "./GreyCard.vue?vue&type=template&id=06d0333f&scoped=true"
const script = {}

import "./GreyCard.vue?vue&type=style&index=0&id=06d0333f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d0333f"],['__file',"src/components/GreyCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06d0333f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06d0333f', __exports__)) {
    api.reload('06d0333f', __exports__)
  }
  
  module.hot.accept("./GreyCard.vue?vue&type=template&id=06d0333f&scoped=true", () => {
    api.rerender('06d0333f', render)
  })

}


export default __exports__